import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  TextField,
  TablePagination,
  CircularProgress,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import * as XLSX from "xlsx";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MuiHeader from "../../components/MuiHeader";
import Swal from "sweetalert2";
import {
  createPrakasakData,
  deletePrakasakData,
  getPrakasakData,
  deletePrakasakDataData,
  deleteRemoteInstruction,
  updateRemoteInstruction,
  getRemoteInstruUploadStatus,
  flagRemoteInstruUploadComplete,
} from "./prakasak.Thunk";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import MuiLoader from "../../components/MuiLoader";
import Spinner from "../../components/Spinner";

const PrakashakData = () => {
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [jsonTable, setJsonTable] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [editingIndices, setEditingIndices] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [file, setFile] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [studentData, setStudentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  console.log("selectedOption", selectedOption);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [isSMSClicked, setIsSMSClicked] = useState(false);
  const [isIVRSClicked, setIsIVRSClicked] = useState(false);
  const [isAutoCallsClicked, setIsAutoCallsClicked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [currentType, setCurrentType] = useState(null);

  const hiddenColumns = ["_id", "__v", "createdAt"];

  const requiredColumnsIvrs = [
    "phone_number",
    "date",
    "time",
    "subject",
    "status",
    // "duration",
    // "ivr_flow_finished",
  ];

  const requiredColumnsCalls = [
    "phone_number",
    "class",
    "status",
    "subject",
    // "duration",
  ];

  const requiredColumnsSms = [
    "phone_number",
    "date",
    "time",
    "subject",
    // "delivered",
  ];

  const classList = [
    { value: 1, text: "1" },
    { value: 2, text: "2" },
    { value: 3, text: "3" },
    { value: 4, text: "4" },
    { value: 5, text: "5" },
  ];

  const statusList = [
    { value: "answered", text: "Answered" },
    { value: "not_answered", text: "not answered" },
    { value: "busy", text: "Busy" },
    { value: "failed", text: "Failed" },
  ];
  const subjectList = [
    { value: "odia", text: "odia" },
    { value: "evs", text: "EVS" },
    { value: "english", text: "English" },
    { value: "maths", text: "Math" },
  ];

  const select_option_list = [
    { value: "ivrs", text: "IVRS" },
    { value: "auto_calls", text: "Automated Calls" },
    { value: "sms", text: "SMS" },
  ];

  const handleSelectedOption = (e) => {
    // setLoading(true);
    const newSelectedOption = e?.target?.value;
    setSelectedOption(e?.target?.value);
    setFile(null);
    if (
      newSelectedOption !== selectedOption ||
      (studentData.length === 0 && jsonTable.length === 0)
    ) {
      setStudentData([]);
      setJsonTable([]);
    }
    if (e.target.value) {
      const data = {
        selectedOption: e.target.value,
      };
      setLoading(true); // Show loading before the request

      getPrakasakData(data)
        .then((res) => {
          if (res.status === 200) {
            console.log("resData--------->", res.data);
            setStudentData(res.data);
          } else if (res.status === 204) {
            setStudentData([]);
            setJsonTable([]);
          } else {
            console.log("Res status got---------->", res.status);
          }
        })
        .catch((err) => {
          console.log("Error------>", err);
          // Optional: Uncomment the error handling for different status codes
          // if (err.response.status === 500) {
          //   toast.error("Internal server error.");
          // } else if (err.response.status === 504) {
          //   toast.error("Server timeout. Please try again later.");
          // } else {
          //   console.error("An unexpected error occurred:", err);
          //   toast.error(
          //     "An unexpected error occurred. Please try again later."
          //   );
          // }
        })
        .finally(() => {
          setLoading(false); // Hide loading regardless of success or failure
        });
    } else {
      console.log("selected option is none");
    }
    setLoadings(true);
    const params = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      remoteInstruType: e?.target?.value,
    };
    getRemoteInstruUploadStatus(params)
      .then((res) => {
        setLoadings(false);
        if (res.status === 200 && res.data === true) {
          if (e?.target?.value === "ivrs") {
            setIsIVRSClicked(res?.data);
          } else if (e?.target?.value === "sms") {
            setIsSMSClicked(res?.data);
          } else if (e?.target?.value === "auto_calls") {
            setIsAutoCallsClicked(res?.data);
          }
        } else if (res?.status === 204 || res?.status === 500) {
          setLoadings(false);
        } else {
          setLoadings(false);
        }
      })
      .catch((error) => {
        setLoadings(false);
        console.error("Error fetching data:", error);
      });
  };

  const handleFileInputChange = (e) => {
    setStudentData([]);
    const selectedFile = e.target.files[0];
    if (
      selectedFile &&
      selectedFile?.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setFile(selectedFile);
      handleConvertFile(selectedFile);
    } else {
      alert("Invalid file type. Please select an Excel file.");
    }
  };

  const handleConvertFile = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        {
          selectedOption &&
            selectedOption?.length > 0 &&
            selectedOption == "ivrs" &&
            handleConvertIvrs(e.target.result);
        }
        {
          selectedOption &&
            selectedOption?.length > 0 &&
            selectedOption == "auto_calls" &&
            handleConvertCalls(e.target.result);
        }
        {
          selectedOption &&
            selectedOption?.length > 0 &&
            selectedOption == "sms" &&
            handleConvertSms(e.target.result);
        }
      };
      reader.readAsBinaryString(file);
    }
  };

  const handleConvertIvrs = (data) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const json = XLSX.utils.sheet_to_json(worksheet, { defval: "", raw: true });

    const requiredColumnsPresent = requiredColumnsIvrs.every((column) => {
      console.log("json", json);
      if (!json?.length) {
        alert("There are no records in this file");
        setFile("");
        return false;
      } else {
        return Object.keys(json[0]).includes(column);
      }
    });

    if (!requiredColumnsPresent) {
      const missingColumns = requiredColumnsIvrs.filter(
        (column) => json.length > 0 && !Object.keys(json[0]).includes(column)
      );
      alert(
        `Invalid file: Required columns are missing - ${missingColumns.join(
          ", "
        )}`
      );
      setFile("");
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    const missingDataColumns = requiredColumnsIvrs.filter(
      (column) =>
        json.length > 0 &&
        json.some((row) => !row[column] || row[column] === "")
    );

    const missingDataRows = json.filter((row) =>
      requiredColumnsIvrs.some((column) => !row[column] || row[column] === "")
    );

    if (missingDataRows.length > 0) {
      alert(
        `Invalid file: Some rows are missing data in required columns - Columns: ${missingDataColumns.join(
          ", "
        )}`
      );
      setFile("");
      window.location.reload();
      return;
    }

    console.log("handleConvert", json);
    const updatedJson = json.map((item) => {
      let date = item.date;
      if (!isNaN(date)) {
        date = new Date((date - (25567 + 2)) * 86400 * 1000)
          .toISOString()
          .slice(0, 10);
      }

      let time = item.time;

      if (time !== "" && !isNaN(parseFloat(time))) {
        const totalSeconds = time * 86400;
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);
        time = `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      } else {
        time = ""; // Set to empty string if time is not a number
      }

      // Convert time to seconds if it's in duration format like "1:11"
      if (
        item.duration &&
        typeof item.duration === "string" &&
        item.duration.includes(":")
      ) {
        const [minutes, seconds] = item.duration.split(":").map(Number);
        item.duration = minutes * 60 + seconds;
      }

      // Add country code to phone number
      if (item.phone_number && typeof item.phone_number === "string") {
        item.phone_number = `91${item.phone_number}`;
      }

      return {
        ...item,
        date: date,
        time: time.toString()?.slice(0, -3),
      };
    });

    console.log("updatedJson", updatedJson);
    setJsonTable(updatedJson);
    // handleFileUpload(updatedJson);
  };

  const handleConvertCalls = (data) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const json = XLSX.utils.sheet_to_json(worksheet, {
      defval: "",
      raw: false, // Keep date values as they are in the Excel file
      dateNF: "YYYY/MM/DD HH:mm:ss", // Specify the date format
    });

    json.forEach((row) => {
      Object.keys(row).forEach((key) => {
        if (
          typeof row[key] === "string" &&
          /\d{4}\/\d{2}\/\d{2}/.test(row[key])
        ) {
          const dateParts = row[key].split("/");
          const formattedDate = `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`;
          row[key] = formattedDate;
        }
      });
    });

    const requiredColumnsPresent = requiredColumnsCalls.every((column) => {
      console.log("json", json);
      if (!json?.length) {
        alert("There are no records in this file");
        setFile("");
        return false;
      } else {
        return Object.keys(json[0]).includes(column);
      }
    });

    if (!requiredColumnsPresent) {
      const missingColumns = requiredColumnsCalls.filter(
        (column) => json.length > 0 && !Object.keys(json[0]).includes(column)
      );
      alert(
        `Invalid file: Required columns are missing - ${missingColumns.join(
          ", "
        )}`
      );
      setFile("");
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    const missingDataColumns = requiredColumnsCalls.filter(
      (column) =>
        json.length > 0 &&
        json.some((row) => !row[column] || row[column] === "")
    );
    const missingDataRows = json.filter((row) =>
      requiredColumnsCalls.some((column) => !row[column] || row[column] === "")
    );

    if (missingDataRows.length > 0) {
      alert(
        `Invalid file: Some rows are missing data in required columns - Columns: ${missingDataColumns.join(
          ", "
        )}`
      );
      setFile("");
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    console.log("handleConvert", json);
    const updatedJson = json?.map((row) => {
      Object.keys(row).forEach((key) => {
        // Date formatting
        if (
          typeof row[key] === "string" &&
          /\d{4}\/\d{2}\/\d{2}/.test(row[key])
        ) {
          const dateParts = row[key].split("/");
          const formattedDate = `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`;
          row[key] = formattedDate;
        }

        // Convert class to number
        if (key === "class" && typeof row[key] === "string") {
          row[key] = Number(row[key]);
        }

        // Convert duration to number
        if (key === "duration" && typeof row[key] === "string") {
          row[key] = Number(row[key]);
        }

        // Update status values
        if (key === "status") {
          switch (row[key].trim().toLowerCase().replace(/\s+/g, "")) {
            case "success":
              row[key] = "answered";
              break;
            case "callsuccessful":
              row[key] = "answered";
              break;
            case "noanswer":
              row[key] = "not_answered";
              break;
            case "failed":
              row[key] = "failed";
              break;
            case "busy":
              row[key] = "busy";
              break;
            case "congestion":
              row[key] = "congestion";
              break;
            case "":
              row[key] = "failed";
              break;
            default:
              break;
          }
        }

        // Handle subject values
        if (key === "subject") {
          console.log(`Original subject value: "${row[key]}"`);
          switch (row[key].trim().toLowerCase()) {
            case "math":
              row[key] = "maths";
              break;
            case "odia":
              row[key] = "odia";
              break;
            case "nudge msg":
              row[key] = "nudge";
              break;
            case "":
              row[key] = "na";
              break;
            default:
              console.warn(`Unexpected subject value: "${row[key]}"`);
              break;
          }
        }

        // Add country code to phone number
        if (key === "phone_number" && typeof row[key] === "string") {
          row[key] = `91${row[key]}`;
        }
      });

      return row;
    });

    console.log("updatedJson", updatedJson);
    setJsonTable(updatedJson);
  };

  const handleConvertSms = (data) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const json = XLSX.utils.sheet_to_json(worksheet, {
      defval: "",
      raw: false, // Keep date values as they are in the Excel file
      dateNF: "YYYY/MM/DD HH:mm:ss", // Specify the date format
    });

    const requiredColumnsPresent = requiredColumnsSms.every((column) => {
      console.log("json", json);
      if (!json?.length) {
        alert("There is no records in this file");
        setFile("");
        return false;
      } else {
        return Object.keys(json[0]).includes(column);
      }
    });

    if (!requiredColumnsPresent) {
      const missingColumns = requiredColumnsSms.filter(
        (column) => json.length > 0 && !Object.keys(json[0]).includes(column)
      );
      alert(
        `Invalid file: Required columns are missing - ${missingColumns.join(
          ", "
        )}`
      );
      setFile("");
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    const missingDataColumns = requiredColumnsSms.filter(
      (column) =>
        json.length > 0 &&
        json.some((row) => !row[column] || row[column] === "")
    );

    const missingDataRows = json.filter((row) =>
      requiredColumnsSms.some((column) => !row[column] || row[column] === "")
    );

    if (missingDataRows.length > 0) {
      alert(
        `Invalid file: Some rows are missing data in required columns - Columns: ${missingDataColumns.join(
          ", "
        )}`
      );
      setFile("");
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    console.log("handleConvert", json);
    const updatedJson = json.map((item) => {
      let date = item.date;
      console.log("date---->", date);
      if (date) {
        // Check if the date is already in YYYY-MM-DD format
        const dateFormat = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateFormat.test(date)) {
          if (date.includes("-")) {
            const [day, month, year] = date.split("-");
            const fullYear = year.length === 2 ? `20${year}` : year;
            const dateObj = new Date(`${fullYear}-${month}-${day}`);

            // Check if dateObj is valid
            if (!isNaN(dateObj.getTime())) {
              date = dateObj.toISOString().slice(0, 10);
            } else {
              date = item.date; // Or any other default value you prefer
            }
          }
        }
      }

      let time = item.time;

      if (time) {
        const timeFormat = /(\d{1,2}):(\d{2}):(\d{2})\s*([AP]M)/i;
        const match = time.match(timeFormat);

        if (match) {
          let [_, hour, minute, second, period] = match;
          hour = parseInt(hour);

          if (period.toUpperCase() === "PM" && hour !== 12) {
            hour += 12;
          } else if (period.toUpperCase() === "AM" && hour === 12) {
            hour = 0;
          }

          time = `${hour.toString().padStart(2, "0")}:${minute}:${second}`;
        } else {
          time = "00:00:00"; // Default to "00:00:00" if time doesn't match the format
        }
      } else {
        time = "00:00:00";
      }

      Object.keys(item).forEach((key) => {
        if (item[key] === "-") {
          item[key] = "";
        }
      });

      if (item.phone_number) {
        item.phone_number = `91${item.phone_number}`;
      }

      if (item.delivered.trim().toLowerCase() === "delivered") {
        item.delivered = true;
      } else if (item.delivered.trim().toLowerCase() === "dnd") {
        item.delivered = false;
      } else if (item.delivered.trim().toLowerCase() === "failed") {
        item.delivered = false;
      } else if (item.delivered.trim() === "") {
        item.delivered = false;
      }

      if (item.subject.trim() === "") {
        item.subject = "na";
      } else if (item.subject.trim().toLowerCase() === "math") {
        item.subject = "math";
      } else if (item.subject.trim().toLowerCase() === "odia") {
        item.subject = "odia";
      }

      if (item.class.trim() === "") {
        item.class = "-1"; // Default to "-1" if class is empty
      }

      return {
        ...item,
        date: date,
        time: time.toString(),
      };
    });
    console.log("updatedJson", updatedJson);
    setJsonTable(updatedJson);
    // handleFileUpload(updatedJson);
  };

  const handleSubmit = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit this record?",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "blue",
      confirmButtonText: "Yes, submit it!",
    }).then((value) => {
      if (value?.isConfirmed) {
        setSaveLoading(true);
        // console.log("jsonData", jsonData);
        const body = {
          type: selectedOption,
          recordsArr: jsonTable,
        };
        console.log("body====================>", body);
        createPrakasakData(body)
          .then((res) => {
            console.log("res", res);
            if (res.status === 200) {
              alert("Successfully created");
              setJsonTable("");
              setSaveLoading(false);
              setJsonData("");
              setFile("");
              setSelectedOption("");
              // setTimeout(() => {
              //   window.location.reload();
              // }, 500);
            } else if (res.status === 400) {
              setSaveLoading(false);
              alert("Create failed. Please try again.");
            }
          })
          .catch((error) => {
            console.error("Create failed:", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
            setSaveLoading(false);
          });
      }
    });
  };

  const handleAllDataDelete = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete All the record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      confirmButtonText: "Yes, delete it!",
    }).then(async (value) => {
      if (value.isConfirmed) {
        // Call your delete API with the studentId
        setDeleteLoading(true);
        const body = {
          type: selectedOption,
          recordsArr: studentData,
        };
        try {
          console.log("body----------->", body);
          const response = await deletePrakasakData(body);
          if (response.status === 200) {
            // Swal.fire({
            //   icon: "success",
            //   title: "Success",
            //   text: `${response?.data?.msg} of ${response?.data?.resp?.deletedCount} records`,
            // });
            setDeleteLoading(false);
            alert("successfully Deleted");
          } else {
            // Swal.fire({
            //   icon: "error",
            //   title: "Error",
            //   text: response.data.msg || "Failed to delete records!",
            // });
            setDeleteLoading(false);
            alert("Failed to delete");
          }
          setTimeout(() => {
            window.location.reload();
          }, 500);
          // console.log("delete", response);
        } catch (error) {
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
          setDeleteLoading(false);
          console.error("Delete failed:", error);
        }
      }
    });
  };

  // const handleEdit = () => {
  //   if (editingIndices.length === 0) {
  //     setEditingIndices([...Array(jsonTable.length).keys()]);
  //   } else {
  //     setEditingIndices([]);
  //   }
  // };

  const handleReset = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "All fields will be clear",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, reset it!",
    }).then((value) => {
      // console.log("alert", value);
      if (value.isConfirmed) {
        setJsonTable("");
        setJsonData("");
        setFile("");
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    setFile(e.dataTransfer.files[0]);
    handleConvertFile(e.dataTransfer.files[0]);
  };

  const handleCellChange = (rowIndex, key, value) => {
    // Update the jsonTable with the edited value
    const updatedJsonTable = [...jsonTable];
    updatedJsonTable[rowIndex][key] = value;
    setJsonTable(updatedJsonTable);
    setJsonData(updatedJsonTable);
    // setJsonData(JSON.stringify(updatedJsonTable, null, 2));
  };
  const renderEditableCell = (value, rowIndex, key) => {
    const isEditable = editingIndices.includes(rowIndex);
    const isHiddenColumn = hiddenColumns.includes(key);

    return (
      <td
        key={key}
        style={{
          padding: "10px",
          border: "1px solid #dddddd",
          display: isHiddenColumn ? "none" : "table-cell",
        }}
      >
        {isEditable ? (
          <TextField
            value={value}
            onChange={(e) => handleCellChange(rowIndex, key, e.target.value)}
          />
        ) : typeof value === "boolean" ? (
          value.toString()
        ) : (
          <span>{value}</span>
        )}
      </td>
    );
  };

  // useEffect(() => {
  //   setLoading(true);
  //   getPrakasak()
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setStudentData(res.data);
  //         setLoading(false);
  //       } else if (res?.status === 204 || res?.status === 500) {
  //         // alert(`No Student Records Available`);
  //         setLoading(false);
  //       } else {
  //         setLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.error("Error fetching data:", error);
  //     });
  // }, []);

  const handleDeleteIndividualData = (item) => {
    console.log("item---->", item, selectedOption);
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log("Data received to delete------->", item);

        const data = {
          type: selectedOption,
          _id: item._id,
        };

        // const { type: selectedOption, _id } = item;
        try {
          const response = await deleteRemoteInstruction(data);
          console.log("res delete---->", response.data);
          if (response.status === 200) {
            toast.success("successfully Deleted");

            const data = {
              selectedOption: selectedOption,
            };
            setLoading(true); // Show loading before the request

            getPrakasakData(data)
              .then((res) => {
                if (res.status === 200) {
                  console.log("resData--------->", res.data);
                  setStudentData(res.data);
                } else if (res.status === 204) {
                  setStudentData([]);
                  setJsonTable([]);
                } else {
                  console.log("Res status got---------->", res.status);
                }
              })
              .catch((err) => {
                console.log("Error------>", err);
                // Optional: Uncomment the error handling for different status codes
                // if (err.response.status === 500) {
                //   toast.error("Internal server error.");
                // } else if (err.response.status === 504) {
                //   toast.error("Server timeout. Please try again later.");
                // } else {
                //   console.error("An unexpected error occurred:", err);
                //   toast.error(
                //     "An unexpected error occurred. Please try again later."
                //   );
                // }
              })
              .finally(() => {
                setLoading(false); // Hide loading regardless of success or failure
              });
          } else {
            toast.error(" Delete Error");
          }
        } catch (err) {
          toast.error("Delete Error in catch block");
          if (err.response.status === 500) {
            toast.error("Internal server error.");
          } else if (err.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", err);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        }
      }
    });
  };

  const [updateData, setUpdateData] = useState(
    selectedOption === "ivrs"
      ? {
          createdAt: "",
          phone_number: "",
          status: "",
          duration: "",
          subject: "",
          ivr_flow_finished: "",
          _id: "",
        }
      : selectedOption === "auto_calls"
      ? {
          class: "",
          phone_number: "",
          status: "",
          duration: "",
          createdAt: "",
          _id: "",
        }
      : selectedOption === "sms"
      ? {
          phone_number: "",
          subject: "",
          createdAt: "",
          delivered: "",
          _id: "",
        }
      : null
  );

  const openUpdateModalOnClick = (item) => {
    setOpenUpdateModal(true);
    if (selectedOption === "ivrs") {
      setUpdateData({
        phone_number: item.phone_number,
        status: item.status,
        duration: item.duration,
        subject: item.subject,
        createdAt: item.createdAt,
        ivr_flow_finished: item.ivr_flow_finished,
        _id: item._id,
      });
    } else if (selectedOption === "auto_calls") {
      setUpdateData({
        class: item.class,
        phone_number: item.phone_number,
        status: item.status,
        duration: item.duration,
        createdAt: item.createdAt,
        _id: item._id,
      });
    } else {
      setUpdateData({
        phone_number: item.phone_number,
        subject: item.subject,
        createdAt: item.createdAt,
        delivered: item.delivered,
        _id: item._id,
      });
    }
  };

  const closeUpdateModalOnClick = () => {
    setOpenUpdateModal(false);
    if (selectedOption === "ivrs") {
      setUpdateData({
        createdAt: "",
        phone_number: "",
        status: "",
        duration: "",
        subject: "",
        ivr_flow_finished: "",
        _id: "",
      });
    } else if (selectedOption === "auto_calls") {
      setUpdateData({
        class: "",
        phone_number: "",
        status: "",
        duration: "",
        createdAt: "",
        _id: "",
      });
    } else if (selectedOption === "sms") {
      setUpdateData({
        phone_number: "",
        subject: "",
        createdAt: "",
        delivered: "",
        _id: "",
      });
    } else {
      console.log("No update data is there");
    }
  };

  // const fetchData = async () => {
  //   const data = {
  //     selectedOption: "ivrs",
  //   };
  //   const res = await getPrakasakData(data);
  //   console.log("resget------>", res);
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const handleUpdateData = async () => {
    console.log("update---->", selectedOption, updateData);
    setLoading(true);
    try {
      const body = {
        updateData,
        type: selectedOption,
        _id: updateData._id,
      };

      const mergedData = {
        ...body.updateData,
        type: body.type,
        _id: body._id,
      };
      console.log("body---->", mergedData);
      const response = await updateRemoteInstruction(mergedData);
      console.log("res update---->", response.data, response.status);
      if (response.status === 200) {
        setLoading(false);
        // fetchData();
        // setTimeout(() => {
        //   window.location.reload();
        // }, 500);
        const data = {
          selectedOption: selectedOption,
        };
        setLoading(true); // Show loading before the request

        getPrakasakData(data)
          .then((res) => {
            if (res.status === 200) {
              console.log("resData--------->", res.data);
              setStudentData(res.data);
            } else if (res.status === 204) {
              setStudentData([]);
              setJsonTable([]);
            } else {
              console.log("Res status got---------->", res.status);
            }
          })
          .catch((err) => {
            console.log("Error------>", err);
            // Optional: Uncomment the error handling for different status codes
            // if (err.response.status === 500) {
            //   toast.error("Internal server error.");
            // } else if (err.response.status === 504) {
            //   toast.error("Server timeout. Please try again later.");
            // } else {
            //   console.error("An unexpected error occurred:", err);
            //   toast.error(
            //     "An unexpected error occurred. Please try again later."
            //   );
            // }
          })
          .finally(() => {
            setLoading(false); // Hide loading regardless of success or failure
          });

        setUpdateData({
          student_name: "",
          class: "",
          phone_number: "",
          status: "",
          duration: "",
          subject: "",
        });
        setOpenUpdateModal(false);
        toast.success("Update successfully!");
      } else {
        setLoading(false);
        toast.error("update failed!");
      }
    } catch (err) {
      setLoading(false);

      if (err.response.status === 500) {
        toast.error("Internal server error.");
      } else if (err.response.status === 504) {
        toast.error("Server timeout. Please try again later.");
      } else {
        console.error("An unexpected error occurred:", err);
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }

    //toast.success("Update done", [{ style: { backgroundColor: "yellow" } }]);
    // setUpdateData({
    //   student_name: "",
    //   clas: "",
    //   phone_number: "",
    //   status: "",
    //   duration: "",
    //   subject: "",
    // });
    //setOpenUpdateModal(false);
  };

  const handleAutomate = (type) => {
    setCurrentType(type);
    setOpenModal(true); // Open the confirmation modal
  };

  const handleConfirm = async () => {
    try {
      const body = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        uploadCompletedBy: new Date().toISOString().split("T")[0],
        remoteInstruType: selectedOption,
      };
      const response = await flagRemoteInstruUploadComplete(body);
      console.log("res update---->", response.data, response.status);
      if (response.status === 200) {
        if (currentType === "sms") {
          setLoading(false);
          setIsSMSClicked(true);
          setSelectedOption("sms");
          toast.success("Update successfully!");
        } else if (currentType === "ivrs") {
          setLoading(false);
          setIsIVRSClicked(true);
          setSelectedOption("ivrs");
          toast.success("Update successfully!");
        } else if (currentType === "auto_calls") {
          setLoading(false);
          setIsAutoCallsClicked(true); // Disable IVRS button
          setSelectedOption("auto_calls");
          toast.success("Update successfully!");
        }
      } else {
        setLoading(false);
        toast.error("update failed!");
      }
    } catch (err) {
      setLoading(false);
      if (err.response.status === 500) {
        toast.error("Internal server error.");
      } else if (err.response.status === 504) {
        toast.error("Server timeout. Please try again later.");
      } else {
        console.error("An unexpected error occurred:", err);
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
    setOpenModal(false); // Close the modal
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal without proceeding
  };
  console.log("updateData------------------->", updateData);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <MuiHeader header="Prakashak (IVRS/Calls/SMS)" />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="Type_select">Type</InputLabel>
          <Select
            labelId="Type_select"
            id="Type_select"
            value={selectedOption}
            label="Type"
            onChange={handleSelectedOption}
          >
            <MenuItem value="">None</MenuItem>
            {select_option_list &&
              select_option_list.length > 0 &&
              select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        {selectedOption && (
          <>
            {selectedOption === "sms" && studentData.length > 0 && (
              <Button
                onClick={() => handleAutomate("sms")}
                variant="contained"
                color="warning"
                style={{ marginRight: "10px" }}
                disabled={isSMSClicked}
              >
                Mark complete ✓
              </Button>
            )}
            {selectedOption === "ivrs" && studentData.length > 0 && (
              <Button
                onClick={() => handleAutomate("ivrs")}
                variant="contained"
                color="warning"
                style={{ marginRight: "10px" }}
                disabled={isIVRSClicked}
              >
                Mark complete ✓
              </Button>
            )}
            {selectedOption === "auto_calls" && studentData.length > 0 && (
              <Button
                onClick={() => handleAutomate("auto_calls")}
                variant="contained"
                color="warning"
                style={{ marginRight: "10px" }}
                disabled={isAutoCallsClicked}
              >
                Mark complete ✓
              </Button>
            )}
          </>
        )}

        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>Confirmation</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to automate this process for {currentType}?
              This action can only be done once a month.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="primary">
              No
            </Button>
            <Button onClick={handleConfirm} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        {isSMSClicked === true && selectedOption === "sms" && (
          <div
            style={{
              color: "red",
              fontSize: "24px",
              fontWeight: "bold",
              // marginTop: "10px",
            }}
          >
            Warning: The SMS button can only be pressed once a month!
          </div>
        )}

        {isIVRSClicked === true && selectedOption === "ivrs" && (
          <div
            style={{
              color: "red",
              fontSize: "24px",
              fontWeight: "bold",
              // marginTop: "10px",
            }}
          >
            Warning: The IVRS button can only be pressed once a month!
          </div>
        )}
        {isAutoCallsClicked === true && selectedOption === "auto_calls" && (
          <div
            style={{
              color: "red",
              fontSize: "24px",
              fontWeight: "bold",
              // marginTop: "10px",
            }}
          >
            Warning: The Auto Calls button can only be pressed once a month!
          </div>
        )}
      </div>
      {selectedOption && selectedOption?.length > 0 ? (
        <>
          {isIVRSClicked ? null : selectedOption === "ivrs" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: isDragOver ? "2px dashed blue" : "2px dashed #aaa",
                padding: "20px",
                borderRadius: "6px",
                marginBottom: "20px",
                width: "40%",
              }}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div
                style={{
                  flex: "1",
                  marginRight: "10px",
                  textAlign: "center",
                  marginLeft: "50px",
                }}
              >
                <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                  <UploadFileIcon size={30} />
                  <p style={{ margin: "10px 0", fontSize: "14px" }}>
                    Drag & Drop or <br /> Click to Select File
                  </p>
                </label>
                <input
                  id="fileInput"
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={handleFileInputChange}
                  style={{ display: "none" }}
                />
                {file &&
                  file?.type ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && (
                    <p style={{ margin: "0", marginRight: "10px" }}>
                      Selected File: {file.name}
                    </p>
                  )}
              </div>
            </div>
          ) : null}
          {isSMSClicked ? null : selectedOption === "sms" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: isDragOver ? "2px dashed blue" : "2px dashed #aaa",
                padding: "20px",
                borderRadius: "6px",
                marginBottom: "20px",
                width: "40%",
              }}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div
                style={{
                  flex: "1",
                  marginRight: "10px",
                  textAlign: "center",
                  marginLeft: "50px",
                }}
              >
                <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                  <UploadFileIcon size={30} />
                  <p style={{ margin: "10px 0", fontSize: "14px" }}>
                    Drag & Drop or <br /> Click to Select File
                  </p>
                </label>
                <input
                  id="fileInput"
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={handleFileInputChange}
                  style={{ display: "none" }}
                />
                {file &&
                  file?.type ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && (
                    <p style={{ margin: "0", marginRight: "10px" }}>
                      Selected File: {file.name}
                    </p>
                  )}
              </div>
            </div>
          ) : null}
          {isAutoCallsClicked ? null : selectedOption === "auto_calls" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: isDragOver ? "2px dashed blue" : "2px dashed #aaa",
                padding: "20px",
                borderRadius: "6px",
                marginBottom: "20px",
                width: "40%",
              }}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div
                style={{
                  flex: "1",
                  marginRight: "10px",
                  textAlign: "center",
                  marginLeft: "50px",
                }}
              >
                <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                  <UploadFileIcon size={30} />
                  <p style={{ margin: "10px 0", fontSize: "14px" }}>
                    Drag & Drop or <br /> Click to Select File
                  </p>
                </label>
                <input
                  id="fileInput"
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={handleFileInputChange}
                  style={{ display: "none" }}
                />
                {file &&
                  file?.type ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && (
                    <p style={{ margin: "0", marginRight: "10px" }}>
                      Selected File: {file.name}
                    </p>
                  )}
              </div>
            </div>
          ) : null}

          {studentData && studentData?.length > 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                {studentData?.length} records found
              </div>
              {deleteLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <Button
                  onClick={handleAllDataDelete}
                  variant="contained"
                  color="error"
                  style={{ marginRight: "10px" }}
                >
                  Delete Data
                </Button>
              )}
            </div>
          ) : null}

          {loading ? (
            <MuiLoader open={loading} />
          ) : jsonTable && jsonTable?.length > 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginTop: "20px",
                  paddingBottom: "20px",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                {jsonTable?.length} records found
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                  paddingBottom: "20px",
                }}
              >
                <Button
                  onClick={handleReset}
                  variant="contained"
                  color="inherit"
                  style={{ marginRight: "10px" }}
                >
                  Reset
                </Button>
                {saveLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    style={{ marginRight: "10px" }}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </div>
          ) : null}

          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner onLoadComplete={() => setLoading(false)} />
            </div>
          ) : studentData && studentData?.length > 0 ? (
            <div
              style={{
                width: "100%",
                // margin: "20px",
                // alignSelf: "center",
              }}
            >
              {studentData && (
                <div
                  style={{
                    height: "700px",
                    overflowY: "auto",
                  }}
                >
                  <table
                    style={{
                      minWidth: "800px",
                      width: "100%",
                      display: "table",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: "#f2f2f2",
                        position: "sticky",
                        top: "0",
                      }}
                    >
                      <tr>
                        <th
                          key="no"
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          Sl. no
                        </th>
                        {studentData &&
                          studentData?.length > 0 &&
                          Object.keys(studentData[0])
                            .filter((key) => !hiddenColumns.includes(key))
                            .map((key) => (
                              <th
                                key={key}
                                style={{
                                  border: "1px solid #dddddd",
                                  padding: "10px",
                                }}
                              >
                                {key}
                              </th>
                            ))}
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {studentData &&
                        studentData?.length > 0 &&
                        studentData
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                              }}
                            >
                              <TableCell>{index + 1}</TableCell>
                              {Object.entries(row).map(([key, value], idx) =>
                                renderEditableCell(value, index, key)
                              )}
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: 20,
                                    justifyContent: "space-evenly",
                                  }}
                                >
                                  <EditIcon
                                    style={{ color: "blue", cursor: "pointer" }}
                                    onClick={() => openUpdateModalOnClick(row)}
                                  />
                                  <DeleteIcon
                                    style={{ color: "red", cursor: "pointer" }}
                                    onClick={() =>
                                      handleDeleteIndividualData(row)
                                    }
                                  />
                                </div>
                              </TableCell>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ) : jsonTable && jsonTable?.length > 0 ? (
            <div
              style={{
                width: "100%",
                // margin: "20px",
                // alignSelf: "center",
              }}
            >
              {jsonTable && (
                <div
                  style={{
                    height: "400px",
                    overflowY: "auto",
                  }}
                >
                  <table
                    style={{
                      minWidth: "800px",
                      width: "100%",
                      display: "table",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: "#f2f2f2",
                        position: "sticky",
                        top: "0",
                      }}
                    >
                      <tr>
                        <th
                          key="no"
                          style={{
                            border: "1px solid #dddddd",
                            padding: "10px",
                          }}
                        >
                          No Records
                        </th>
                        {jsonTable &&
                          jsonTable?.length > 0 &&
                          Object.keys(jsonTable[0])
                            // .filter((key) => !hiddenColumns.includes(key))
                            .map((key) => (
                              <th
                                key={key}
                                style={{
                                  border: "1px solid #dddddd",
                                  padding: "10px",
                                }}
                              >
                                {key}
                              </th>
                            ))}
                      </tr>
                    </thead>

                    <tbody>
                      {jsonTable &&
                        jsonTable?.length > 0 &&
                        jsonTable?.map((row, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            {Object.entries(row).map(([key, value], idx) =>
                              renderEditableCell(value, index, key)
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <></>
            </div>
          )}
        </>
      ) : null}
      {selectedOption && studentData?.length > 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            // marginTop: "20px",
          }}
        >
          <Button
            onClick={() => setPage((prevPage) => Math.max(prevPage - 1, 0))}
            disabled={page === 0}
          >
            Previous
          </Button>
          <span style={{ margin: "0 10px" }}>{page + 1}</span>
          <Button
            onClick={() =>
              setPage((prevPage) =>
                Math.min(
                  prevPage + 1,
                  Math.ceil(studentData.length / rowsPerPage) - 1
                )
              )
            }
            disabled={page === Math.ceil(studentData.length / rowsPerPage) - 1}
          >
            Next
          </Button>
        </div>
      ) : null}
      {selectedOption === "auto_calls" && (
        <Modal open={openUpdateModal} onClose={closeUpdateModalOnClick}>
          <Box sx={style}>
            <TextField
              id="outlined-multiline-static"
              label="Phone number"
              multiline
              rows={2}
              variant="outlined"
              sx={{
                width: 250,
                marginTop: 2,
                marginLeft: 4,
              }}
              size="small"
              value={updateData?.phone_number}
              onChange={(e) => {
                let phoneNumber = e.target.value;
                phoneNumber = phoneNumber.replace(/\D/g, "");
                phoneNumber = phoneNumber.slice(0, 10);
                setUpdateData({
                  ...updateData,
                  phone_number: phoneNumber,
                });
              }}
            />
            <FormControl
              sx={{ marginTop: 2, width: 250, marginLeft: 4 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Class</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={updateData?.class}
                label="Class"
                onChange={(e) => {
                  setUpdateData({ ...updateData, class: e.target.value });
                }}
                style={{ padding: "3%" }}
              >
                {classList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              sx={{ marginTop: 2, width: 250, marginLeft: 4 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Status</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={updateData?.status}
                label="status"
                onChange={(e) => {
                  setUpdateData({ ...updateData, status: e.target.value });
                }}
                style={{ padding: "3%" }}
              >
                {statusList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="outlined-multiline-static"
              label="Duration"
              multiline
              rows={2}
              variant="outlined"
              sx={{
                width: 250,
                marginTop: 2,
                marginLeft: 4,
              }}
              size="small"
              value={updateData?.duration}
              onChange={(e) => {
                let dur = e.target.value;
                dur = dur.replace(/\D/g, "");
                dur = dur.slice(0, 10);
                setUpdateData({
                  ...updateData,
                  duration: dur,
                });
              }}
            />

            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Button
                variant="contained"
                sx={{
                  width: 70,
                  marginTop: 2,
                  marginBottom: 1,
                  marginRight: 1,
                }}
                onClick={closeUpdateModalOnClick}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  width: 70,
                  marginTop: 2,
                  marginBottom: 1,
                  marginRight: 1,
                }}
                onClick={handleUpdateData}
                // disabled={loading}
              >
                Update
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      {selectedOption === "ivrs" && (
        <Modal open={openUpdateModal} onClose={closeUpdateModalOnClick}>
          <Box sx={style}>
            <TextField
              id="outlined-multiline-static"
              label="Phone number"
              multiline
              rows={2}
              variant="outlined"
              sx={{
                width: 250,
                marginTop: 2,
                marginLeft: 4,
              }}
              size="small"
              value={updateData?.phone_number}
              onChange={(e) => {
                let phoneNumber = e.target.value;
                phoneNumber = phoneNumber.replace(/\D/g, "");
                phoneNumber = phoneNumber.slice(0, 10);
                setUpdateData({
                  ...updateData,
                  phone_number: phoneNumber,
                });
              }}
            />
            <FormControl
              sx={{ marginTop: 2, width: 250, marginLeft: 4 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Subject</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={updateData?.subject}
                label="subject"
                onChange={(e) => {
                  setUpdateData({ ...updateData, subject: e.target.value });
                }}
                style={{ padding: "3%" }}
              >
                {subjectList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              sx={{ marginTop: 2, width: 250, marginLeft: 4 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Status</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={updateData?.status}
                label="status"
                onChange={(e) => {
                  setUpdateData({ ...updateData, status: e.target.value });
                }}
                style={{ padding: "3%" }}
              >
                {statusList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="outlined-multiline-static"
              label="Duration"
              multiline
              rows={2}
              variant="outlined"
              sx={{
                width: 250,
                marginTop: 2,
                marginLeft: 4,
              }}
              size="small"
              value={updateData?.duration}
              onChange={(e) => {
                let dur = e.target.value;
                dur = dur.replace(/\D/g, "");
                dur = dur.slice(0, 10);
                setUpdateData({
                  ...updateData,
                  duration: dur,
                });
              }}
            />

            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Button
                variant="contained"
                sx={{
                  width: 70,
                  marginTop: 2,
                  marginBottom: 1,
                  marginRight: 1,
                }}
                onClick={closeUpdateModalOnClick}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  width: 70,
                  marginTop: 2,
                  marginBottom: 1,
                  marginRight: 1,
                }}
                onClick={handleUpdateData}
                // disabled={loading}
              >
                Update
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      {selectedOption === "sms" && (
        <Modal open={openUpdateModal} onClose={closeUpdateModalOnClick}>
          <Box sx={style}>
            <TextField
              id="outlined-multiline-static"
              label="Phone number"
              multiline
              rows={2}
              variant="outlined"
              sx={{
                width: 250,
                marginTop: 2,
                marginLeft: 4,
              }}
              size="small"
              value={updateData?.phone_number}
              onChange={(e) => {
                let phoneNumber = e.target.value;
                phoneNumber = phoneNumber.replace(/\D/g, "");
                phoneNumber = phoneNumber.slice(0, 10);
                setUpdateData({
                  ...updateData,
                  phone_number: phoneNumber,
                });
              }}
            />
            <FormControl
              sx={{ marginTop: 2, width: 250, marginLeft: 4 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Subject</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={updateData?.subject}
                label="subject"
                onChange={(e) => {
                  setUpdateData({ ...updateData, subject: e.target.value });
                }}
                style={{ padding: "3%" }}
              >
                {subjectList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Button
                variant="contained"
                sx={{
                  width: 70,
                  marginTop: 2,
                  marginBottom: 1,
                  marginRight: 1,
                }}
                onClick={closeUpdateModalOnClick}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  width: 70,
                  marginTop: 2,
                  marginBottom: 1,
                  marginRight: 1,
                }}
                onClick={handleUpdateData}
                // disabled={loading}
              >
                Update
              </Button>
            </div>
          </Box>
        </Modal>
      )}

      <ToastContainer />
    </div>
  );
};

export default PrakashakData;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
